import { render } from "./PayModal.vue?vue&type=template&id=9cf3336e&scoped=true"
import script from "./PayModal.vue?vue&type=script&lang=js"
export * from "./PayModal.vue?vue&type=script&lang=js"

import "./PayModal.vue?vue&type=style&index=0&id=9cf3336e&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf3336e"]])

export default __exports__